import React, { useEffect, useState } from "react";
import { getSession } from "./auth";
import LoginPage from "./LoginPage";

// Gates the app behind the simple JSON username/password login.
// Wrap your app with <AuthGate>...</AuthGate> to require login.
export default function AuthGate({ children }) {
  const [checking, setChecking] = useState(true);
  const [session, setSession] = useState(null);

  useEffect(() => {
    setSession(getSession());
    setChecking(false);
  }, []);

  if (checking) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        Loading...
      </div>
    );
  }

  if (!session) {
    return <LoginPage onLoggedIn={setSession} />;
  }

  return children;
}
